/******************************************************************************************
 *	Loyalty Membership Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.loyaltyMembershipModal', [])
    .factory(
      'LoyaltyMembershipModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/loyalty-membership-modal.html',
          controller: 'LoyaltyMembershipModalController',
          classNames: 'loyalty-membership-modal'
        });
      }
    )
    .controller(
      'LoyaltyMembershipModalController',
      /* @ngInject */
      function(
        _,
        $filter,
        $locale,
        $log,
        $scope,
        $translate,
        THREE_YEAR_COMMIT_STATUSES,
        CurtainNotifications,
        LoyaltyMembershipModal,
        Settings,
        CustomerLoyalty3yc
      ) {
        if ($scope.loyaltyInfo && $scope.loyaltyInfo.hasThreeYearCommit()) {
          $scope.threeYearCommit = $scope.loyaltyInfo.features.THREE_YEAR_COMMIT;

          // The end date selector is within an ng-if which means it has a child scope. In order
          // to see changes to the select's model here, we must use an object.
          $scope.vm = {};

          if ($scope.loyaltyInfo.isEligibleThreeYearCommit()) {
            $scope.eligibilityString = $translate.instant(
              'loyaltyMembershipModal.notEnrolled.licenseCommitment',
              {seatCount: $filter('numberFormatter')($scope.threeYearCommit.committedSeatCount)},
              undefined,
              false,
              'sceParameters'
            );
          }

          if ($scope.allowDateChange) {
            $scope.loading3ycDateInfo = true;
            CustomerLoyalty3yc.getInfo($scope.customerId)
              .then(function(responseData) {
                // Dates are ISO8602 date strings, for example, 2019-08-27T00:00:01-07:00.
                $scope.endDates = responseData.endDates;

                // The default for the end date selector should be the current end date which is not
                // necessarily the first one in the list. The current end date should always be in
                // the endDates list but check first and, worse case, default to the first date in the
                // list.
                var endDateFound = false;
                _.forEach($scope.endDates, function(date) {
                  if (date === $scope.threeYearCommit.endDate) {
                    endDateFound = true;
                  }
                });
                $scope.vm.selectedEndDate = endDateFound
                  ? $scope.threeYearCommit.endDate
                  : $scope.endDates[0];

                $scope.loading3ycDateInfo = false;
                $scope.loading3ycDateInfoError = false;
              })
              .catch(function(response) {
                $scope.loading3ycDateInfo = false;
                $scope.loading3ycDateInfoError = true;
                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'loyaltyMembershipModal.notifications.no3YCEndDates'
                );
                $log.error('Failed to fetch 3YC', response.data);
              });

            // While the end dates are loading, show the one we have in the disabled selector.
            $scope.endDates = [$scope.threeYearCommit.endDate];
            $scope.vm.selectedEndDate = $scope.endDates[0];

            $scope.submit = function() {
              $scope.submitted = true;

              // selectedEndDate is one of the ISO8602 date strings in endDates.
              if ($scope.vm.selectedEndDate !== $scope.threeYearCommit.endDate) {
                var payload = {
                  endDate: $scope.vm.selectedEndDate
                };

                // This covers the modal with a spinner.
                LoyaltyMembershipModal.setLoadingState();

                CustomerLoyalty3yc.updateInfo($scope.customerId, payload)
                  .then(function(responseData) {
                    // Update the cached data with the new end date.
                    $scope.threeYearCommit.endDate = responseData.endDate;

                    CurtainNotifications.show(
                      CurtainNotifications.SUCCESS,
                      'loyaltyMembershipModal.notifications.submitSuccess',
                      {endDate: $scope.vm.selectedEndDate}
                    );

                    $scope.removeModal();
                  })
                  .catch(function(response) {
                    $log.warn(response.data, response.status);

                    //status is 0 when call is aborted
                    if (response.status !== 0) {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'loyaltyMembershipModal.notifications.submitError'
                      );
                      LoyaltyMembershipModal.unsetLoadingState();
                      $scope.submitted = false;
                      $log.error('Failed to update 3YC', response.data);
                    }
                  });
              } else {
                CurtainNotifications.show(
                  CurtainNotifications.SUCCESS,
                  'loyaltyMembershipModal.notifications.noChange3YCEndDate'
                );
                $scope.removeModal();
              }
            };
          }
        }

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          LoyaltyMembershipModal.remove({cancelled: true});
        };
      }
    );
})();
